let pendingIncomingCall = null
const listeners = new Set()

function notifyListeners() {
    listeners.forEach(listener => {
        try {
            listener(pendingIncomingCall)
        } catch (_error) {
            /* handle listener error */
        }
    })
}

export function setPendingIncomingCall(payload = null) {
    pendingIncomingCall = payload ? { ...payload } : null
    notifyListeners()
}

export function peekPendingIncomingCall() {
    return pendingIncomingCall ? { ...pendingIncomingCall } : null
}

export function consumePendingIncomingCall() {
    if (!pendingIncomingCall) return null
    const current = { ...pendingIncomingCall }
    pendingIncomingCall = null
    notifyListeners()
    return current
}

export function clearPendingIncomingCall(roomId = '') {
    if (!pendingIncomingCall) return
    if (roomId && String(pendingIncomingCall.roomId || '') !== String(roomId)) return
    pendingIncomingCall = null
    notifyListeners()
}

export function subscribePendingIncomingCall(listener) {
    if (typeof listener !== 'function') return () => {}
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
